export const timersInMilliseconds = {
  fortyFiveSeconds: 1000 * 45,
  thirtySeconds: 1000 * 30,
  fifteenSeconds: 1000 * 15,
  fiveMinutes: 60 * 1000 * 5,
  tenMinutes: 60 * 1000 * 10,
}

/* 30 seconds */
export const STORE_AVAILABILITY_POLLING_TIME =
  timersInMilliseconds.thirtySeconds
export const POC_ORDERS_PAGE_POLLING_TIME = timersInMilliseconds.thirtySeconds
export const CHECK_ORDERS_POLLING_TIME = timersInMilliseconds.thirtySeconds

export const BELL_INACTIVITY_THRESHOLD_MS = timersInMilliseconds.tenMinutes

/* 5 minute */
export const PERFORMANCE_KPIS_POLLING_TIME = timersInMilliseconds.fiveMinutes
export const IDEAL_PORTFOLIO_KPI_POLLING_TIME = timersInMilliseconds.fiveMinutes
export const SCHEDULED_ORDERS_COUNT_SIDEBAR_POLLING_TIME =
  timersInMilliseconds.fiveMinutes
export const REPORT_POLLING_TIMEOUT = timersInMilliseconds.fiveMinutes
